export const handleUsuarioIT = (setActiveStep, activeStep) => {
  return setActiveStep(activeStep + 1);
};
